import React, { Suspense } from 'react';
import AppLoader from 'core/ui/components/AppLoader';
import { Layout, Overlay } from './components/style';
import { useTranslation } from 'react-i18next';

export const TemplatePreview: React.FC = () => {
  const { t } = useTranslation(['designs', 'trackingLinks']);

  return (
    <Suspense fallback={<AppLoader />}>
      <Overlay>
        <Layout data-testid="TemplatePreviewLayout">
          <iframe
            title={t('designGallery.form.templatePreviewTitle')}
            srcDoc={localStorage.getItem('templateEditorPreview')}
            style={{ display: 'block', height: '100%' }}
          />
        </Layout>
      </Overlay>
    </Suspense>
  );
};

export default TemplatePreview;
